import React, { useContext } from 'react';

import { HiMoon, HiSun } from 'react-icons/hi';

import { Theme } from '@/contexts/Theme';

const ToggleTheme = () => {
  const { theme, setTheme } = useContext(Theme);

  return (
    <div
      onClick={() => setTheme(theme === 'dark' ? 'light' : 'dark')}
      className='p-2 transition duration-500 ease-in-out bg-white border border-gray-300 rounded-lg shadow-sm cursor-pointer first-letter text-dark focus:ring-offset-2 focus:ring-gray-900-100 focus:outline-none hover:bg-gray-100 focus:ring-4 focus:ring-gray-200 dark:bg-gray-800 dark:text-white dark:border-gray-600 dark:hover:bg-gray-700 dark:hover:border-gray-600 dark:focus:ring-gray-700'
    >
      {theme === 'dark' ? (
        <HiSun className='text-lg md:text-2xl' />
      ) : (
        <HiMoon className='text-lg md:text-2xl' />
      )}
    </div>
  );
};

export default ToggleTheme;
